import { HttpClient } from '@angular/common/http';
import { AfterContentInit, Component } from '@angular/core';
import { Config } from '../Config';


@Component({
  selector: 'app-project-report',
  templateUrl: './project-report.component.html',
  styleUrls: ['./project-report.component.css']
})
export class ProjectReportComponent implements AfterContentInit {

  reportType: 'Aviation' | 'Project' | 'Transit' | 'Anticipated' | 'Under Construction';
  id: string;
  public config = (window as any).config as Config;

  isLoading = false;

  aviationRptData: IAviationData = {
    projectId: null,
    id: '',
    airportName: '',
    description: '',
    federalFiscalYear: '',
    stateFiscalYear: '',
    federalShare: null,
    federalShareStr: '',
    stateShare: null,
    stateShareStr: ''
  };

  transitRptData: ITransitData = {
    agency: '',
    projectTitle: '',
    projectId: '',
    stateFiscalYear: '',
    totalProjectCost: null,
    totalProjectCostStr: ''
  };

  projectRptData: IProjectData = {
    completionDate: '',
    completionFlag: '',
    ntpDate: '',
    ntpFlag: '',
    confirmationStatus: '',
    countyName: '',
    improvementName: '',
    municipalityName: '',
    narrative: '',
    periodOneStart: '',
    periodTwoStart: '',
    periodThreeStart: '',
    periodFourStart: '',
    programStatusCode: '',
    programTitleText: '',
    projectGeographicDescription: '',
    projectId: null,
    projectShortTitleText: '',
    regnExmptNm: '',
    routeNumber: '',
    fundingData: null
  };

  anticipatedPrjRptData: IAnticipatedData = {
    crcPhone: '',
    crcProgramArea: '',
    projectLeadIndicator: '',
    completionDate: '',
    countyCode: '',
    letDate: '',
    phaseEstimatedCostAmount: null,
    phaseType: '',
    projectGeographyDescription: '',
    projectId: '',
    projectImprovementDescription: '',
    projectManagerContactName: '',
    projectManagerEmail: '',
    projectManagerNumber: '',
    projectNarrativeDescription: '',
    projectTitleText: '',
    primaryStateRoute: '',
    responsibleCountyCode: '',
    responsibleCountyName: '',
    oneMapUrl: ''
  };

  underConstructionProjectRptDataArray: IUnderConstructionData[] = [];
  underConstructionProjectRptData: IUnderConstructionData = {
    crcPhone: '',
    crcProgramArea: '',
    projectLeadIndicator: '',
    completionDate: '',
    completionFlag: '',
    letDate: '',
    ntpDate: '',
    ntpFlag: '',
    currentContractAmount: null,
    projectGeographyDescription: '',
    projectId: '',
    projectImprovementDescription: '',
    projectNarrativeDescription: '',
    projectTitleText: '',
    primaryStateRoute: '',
    responsibleCountyName: '',
    businessPartnerBusinessName: '',
    businessPartnerEmail: '',
    businessPartnerFirstName: '',
    businessPartnerLastName: '',
    businessPartnerLegalAddress1: '',
    businessPartnerLegalAddress2: '',
    businessPartnerLegalCity: '',
    businessPartnerLegalState: '',
    businessPartnerLegalZip: '',
    businessPartnerPhoneAreaCode: '',
    businessPartnerPhoneExchange: '',
    businessPartnerPhoneNumber: '',
    businessPartnerTeamMemberRole: '',
    oneMapUrl: '',
    longAddress: '',
  };
  ciicIndex = 0;

  monthsAbbreviated = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
    'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  curDate: string;
  periodOneTotal = 0;
  periodTwoTotal = 0;
  periodThreeTotal = 0;
  periodFourTotal = 0;
  secondFourYearTotal = 0;
  thirdFourYearTotal = 0;
  grandTotal = 0;

  constructor(private http: HttpClient) {
  }

  ngAfterContentInit() {
    this.parseURL();
    this.getReportData();


    const today = new Date();
    const day = today.getDate();
    const monthIndex = today.getMonth();
    const year = today.getFullYear();
    this.curDate = `${this.monthsAbbreviated[monthIndex]} ${day < 10 ? '0' + day : day}, ${year}`;

  }

  async parseURL() {
    const url = window.location.href;

    if (url.includes('reportType=Aviation')) {
      this.reportType = 'Aviation';
      const index = url.indexOf('ProjectID=') + 'ProjectID='.length;
      this.id = url.substring(index, url.length);
    } else if (url.includes('reportType=Project')) {
      this.reportType = 'Project';
      const index = url.indexOf('ProjectID=') + 'ProjectID='.length;
      this.id = url.substring(index, url.length);
    } else if (url.includes('reportType=Transit')) {
      this.reportType = 'Transit';
      const index = url.indexOf('ObjectID=') + 'ObjectID='.length;
      this.id = url.substring(index, url.length);
    } else if (url.includes('reportType=Anticipated')) {
      this.reportType = 'Anticipated';
      const index = url.indexOf('ProjectID=') + 'ProjectID='.length;
      this.id = url.substring(index, url.length);
    } else if (url.includes('reportType=UnderConstruction')) {
      this.reportType = 'Under Construction';
      const index = url.indexOf('ProjectID=') + 'ProjectID='.length;
      this.id = url.substring(index, url.length);
    }
  }

  async getReportData() {
    this.isLoading = true;
    let requestURL = 'api/reports/Get' + this.reportType + 'ReportData?id=' + this.id;

    try {
      if (this.reportType === 'Aviation') {
        this.aviationRptData = (await this.http.get<IAviationData[]>(requestURL).toPromise())[0];

        this.aviationRptData.federalShareStr = this.formatCurrency(this.aviationRptData.federalShare);
        this.aviationRptData.stateShareStr = this.formatCurrency(this.aviationRptData.stateShare);

      } else if (this.reportType === 'Transit') {
        this.transitRptData = (await this.http.get<ITransitData[]>(requestURL).toPromise())[0];

        this.transitRptData.projectTitle =
          this.transitRptData.projectTitle.includes('|') ? 'Multiple Agency Improvements' : this.transitRptData.projectTitle;
        this.transitRptData.totalProjectCostStr = this.formatCurrency(this.transitRptData.totalProjectCost);

      } else if (this.reportType === 'Project') {
        this.projectRptData = (await this.http.get<IProjectData[]>(requestURL).toPromise())[0];

        this.projectRptData.ntpDate = this.formatDate(this.projectRptData.ntpDate);
        this.projectRptData.completionDate = this.formatDate(this.projectRptData.completionDate);
        this.calculateProjectFundingTotals(this.projectRptData.fundingData);

      } else if (this.reportType === 'Anticipated') {
        this.anticipatedPrjRptData = (await this.http.get<IAnticipatedData[]>(requestURL).toPromise())[0];

        this.anticipatedPrjRptData.oneMapUrl = this.config.oneMapUrl + '?ProjectId=' + this.anticipatedPrjRptData.projectId;

      } else if (this.reportType === 'Under Construction') {
        requestURL = requestURL.replace(' ', '');
        this.underConstructionProjectRptDataArray = (await this.http.get<IUnderConstructionData[]>(requestURL).toPromise());
        this.underConstructionProjectRptData = this.underConstructionProjectRptDataArray[0];

        this.underConstructionProjectRptData.oneMapUrl = this.config.oneMapUrl + '?ProjectId=' +
                                                         this.underConstructionProjectRptData.projectId;

        this.underConstructionProjectRptData.longAddress = this.underConstructionProjectRptData.businessPartnerLegalAddress1 +
          ', ' + this.underConstructionProjectRptData.businessPartnerLegalAddress2 + ', ' +
          this.underConstructionProjectRptData.businessPartnerLegalCity + ', ' +
          this.underConstructionProjectRptData.businessPartnerLegalState + ' ' +
          this.underConstructionProjectRptData.businessPartnerLegalZip;

        this.ciicIndex = this.underConstructionProjectRptDataArray.findIndex(x => x.businessPartnerTeamMemberRole === 'CIIC');
      }

    } catch (error) {
      console.error('Error', error);
    } finally {
      this.isLoading = false;
    }

  }

  formatCurrency(amount: number): string {
    if (amount) {
      // Convert number to string and add commas for thousands separator
      const formattedAmount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Add currency symbol and return
      return '$' + formattedAmount;
    }
  }

  formatDate(date: string, est = false, actual = false): string {
    if (date !== '') {
      const m = date.substring(4, 6);
      const d = date.substring(6, 8);
      const y = date.substring(0, 4);

      let ret = m + '/' + d + '/' + y;
      if (est) {
        ret += ' (Estimated)';
      }
      if (actual) {
        ret += ' (Actual)';
      }

      return ret;
    }
  }

  calculateProjectFundingTotals(fundingData: IProjectFundingData[]) {
    for (const fundingYear of fundingData) {
      this.periodOneTotal += fundingYear.tipPeriodOne;
      this.periodTwoTotal += fundingYear.tipPeriodTwo;
      this.periodThreeTotal += fundingYear.tipPeriodThree;
      this.periodFourTotal += fundingYear.tipPeriodFour;
      this.secondFourYearTotal += fundingYear.secondFourYear;
      this.thirdFourYearTotal += fundingYear.thirdFourYear;
    }
    this.grandTotal = this.periodOneTotal + this.periodTwoTotal + this.periodThreeTotal + this.periodFourTotal +
      this.secondFourYearTotal + this.thirdFourYearTotal;
  }

  formatPhoneNumber(phoneNumber: string) {
    if (phoneNumber && phoneNumber.length === 10) {
      return phoneNumber.substring(0, 3) + '.' + phoneNumber.substring(3, 6) + '.' + phoneNumber.substring(6, 10);
    } else {
      return phoneNumber;
    }
  }

}

interface IAviationData {
  projectId: number;
  id: string;
  airportName: string;
  description: string;
  federalFiscalYear: string;
  stateFiscalYear: string;
  federalShare: number;
  federalShareStr: string;
  stateShare: number;
  stateShareStr: string;
}

interface ITransitData {
  agency: string;
  projectTitle: string;
  projectId: string;
  stateFiscalYear: string;
  totalProjectCost: number;
  totalProjectCostStr: string;
}
interface IProjectData {
  completionDate: string;
  completionFlag: string;
  ntpDate: string;
  ntpFlag: string;
  confirmationStatus: string;
  countyName: string;
  improvementName: string;
  municipalityName: string;
  narrative: string;
  periodOneStart: string;
  periodTwoStart: string;
  periodThreeStart: string;
  periodFourStart: string;
  programStatusCode: string;
  programTitleText: string;
  projectGeographicDescription: string;
  projectId: number;
  projectShortTitleText: string;
  regnExmptNm: string;
  routeNumber: string;
  fundingData: IProjectFundingData[];
}

interface IProjectFundingData {
  fundingCategoryCode: string;
  fundingSort: number;
  phaseOrder: string;
  secondFourYear: number;
  thirdFourYear: number;
  tipPeriodOne: number;
  tipPeriodTwo: number;
  tipPeriodThree: number;
  tipPeriodFour: number;
  phaseDescription: string;
}

interface IAnticipatedData {
  crcPhone: string;
  crcProgramArea: string;
  projectLeadIndicator: string;
  completionDate: string;
  countyCode: string;
  letDate: string;
  phaseEstimatedCostAmount: number;
  phaseType: string;
  projectGeographyDescription: string;
  projectId: string;
  projectImprovementDescription: string;
  projectManagerContactName: string;
  projectManagerEmail: string;
  projectManagerNumber: string;
  projectNarrativeDescription: string;
  projectTitleText: string;
  primaryStateRoute: string;
  responsibleCountyCode: string;
  responsibleCountyName: string;
  oneMapUrl: string;
}
interface IUnderConstructionData {
  crcPhone: string;
  crcProgramArea: string;
  projectLeadIndicator: string;
  completionDate: string;
  completionFlag: string;
  letDate: string;
  ntpDate: string;
  ntpFlag: string;
  currentContractAmount: number;
  projectGeographyDescription: string;
  projectId: string;
  projectImprovementDescription: string;
  projectNarrativeDescription: string;
  projectTitleText: string;
  primaryStateRoute: string;
  responsibleCountyName: string;
  businessPartnerBusinessName: string;
  businessPartnerEmail: string;
  businessPartnerFirstName: string;
  businessPartnerLastName: string;
  businessPartnerLegalAddress1: string;
  businessPartnerLegalAddress2: string;
  businessPartnerLegalCity: string;
  businessPartnerLegalState: string;
  businessPartnerLegalZip: string;
  businessPartnerPhoneAreaCode: string;
  businessPartnerPhoneExchange: string;
  businessPartnerPhoneNumber: string;
  businessPartnerTeamMemberRole: string;
  oneMapUrl: string;
  longAddress: string;
}
